<div *ngIf="isLoading" class="loading-overlay">
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
</div>

<div class="container py-3" style="max-width: 1020px">
  <div class="row">
    <div class="col-md-8 mb-3">
      <mat-card class="p-4" style="max-width: 650px">
        <mat-card-title mat-dialog-title class="d-flex align-items-center mb-0">
          <mat-icon class="mr-2">event</mat-icon>
          &nbsp;
          <div>
            {{ 'rooms.make-a-booking.title' | translate }}
          </div>
        </mat-card-title>

        <mat-card-subtitle>
          <div>
            {{ 'rooms.make-a-booking.subtitle' | translate }}
          </div>
        </mat-card-subtitle>

        <mat-divider></mat-divider>

        <mat-card-content>
          <app-calendar-booking [roomId]="roomId"></app-calendar-booking>
        </mat-card-content>
      </mat-card>
    </div>

    <!--Help and Support (START)-->
    <div class="col-md-4 mb-3">
      <mat-card style="height: fit-content">
        <mat-card-header>
          <mat-card-title>
            <h6>
              <mat-icon class="heading-icon mr-2">help</mat-icon>&nbsp;
              {{ 'rooms.make-a-booking.help-and-support.title' | translate }}
            </h6>
            <p style="font-weight: lighter; font-size: small; color: grey">
              {{ 'rooms.make-a-booking.help-and-support.subtitle' | translate }}
            </p>
          </mat-card-title>
        </mat-card-header>

        <mat-divider></mat-divider>
        <mat-card-content>
          <div class="mt-2 pt-2">
            <mat-accordion [multi]="true">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title class="d-flex align-items-center">
                    <mat-icon class="heading-icon mr-2"> event </mat-icon>
                    {{
                      'rooms.make-a-booking.help-and-support.card-1.title'
                        | translate
                    }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                {{
                  'rooms.make-a-booking.help-and-support.card-1.content'
                    | translate
                }}
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <!--Help and Support (END)-->
  </div>
</div>
